import { ResourceView } from '@nexelem/graphne-api';
import { useCustomTranslation } from '../../../../../../hooks';
import { parseName } from '@nexelem/utils';
import { Avatar } from '@nexelem/components';

type AssignedWorkersCardProps = {
  workers?: ResourceView[];
};
export const AssignedWorkersCard = ({ workers }: AssignedWorkersCardProps) => {
  const { tWrapper } = useCustomTranslation('products.productionPlan.settingDrawer.showOnTaskOptions');

  if (!workers?.length) {
    return null;
  }

  return (
    <div className="rounded-xs border border-border-container bg-surface-container-lighter p-4">
      <div className="mb-3 text-t14-sb text-text-secondary">{tWrapper('assignedWorkers')}</div>
      <div className="flex flex-col gap-2">
        {workers.map((worker) => {
          const { firstName, lastName } = parseName(worker.name);
          return (
            <div className="flex gap-2" key={worker.id}>
              <Avatar firstName={firstName} lastName={lastName} />
              <span className="text-s18">{worker.name}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
